/* =========================================
   AOMIH Cursor — Sparkle Trail
   ========================================= */
(function () {
  // Respect reduced motion & touch devices
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;

  var SPARKLE_COUNT = 70;
  var COLORS = (getComputedStyle(document.documentElement)
    .getPropertyValue('--aomih-dot-colors') || '#854917,#FFF9EF,#EAEBBF,#854917,#FFF9EF,#854917')
    .split(',')
    .map(function (c) { return c.trim(); });

  var dots = new Array(SPARKLE_COUNT);
  var pool = [];
  var lastDotTime = 0;

  // Create pool
  for (var i = 0; i < SPARKLE_COUNT; i++) {
    var el = document.createElement('div');
    el.className = 'aomihsparkle';
    el.style.visibility = 'hidden';
    document.body.appendChild(el);
    dots[i] = {
      el: el,
      active: false,
      x: 0,
      y: 0,
      scale: 0
    };
    pool.push(dots[i]);
  }

  function activateDot(x, y) {
    if (!pool.length) return;
    var d = pool.pop();
    d.active = true;
    d.x = x + (Math.random() * 20 - 10);
    d.y = y + (Math.random() * 20 - 10);
    d.scale = 1;
    d.el.style.backgroundColor = COLORS[Math.floor(Math.random() * COLORS.length)];
    d.el.style.visibility = 'visible';
    d.el.style.opacity = '1';
    d.el.style.transform = 'translate3d(' + d.x + 'px,' + d.y + 'px,0) scale(' + d.scale + ')';
  }

  function animate() {
    for (var i = 0; i < dots.length; i++) {
      var d = dots[i];
      if (!d.active) continue;

      d.scale -= 0.02;
      d.y += 0.5;

      if (d.scale <= 0.1) {
        d.active = false;
        d.el.style.visibility = 'hidden';
        pool.push(d);
      } else {
        d.el.style.transform = 'translate3d(' + d.x + 'px,' + d.y + 'px,0) scale(' + d.scale + ')';
      }
    }
    requestAnimationFrame(animate);
  }

  document.addEventListener('mousemove', function (e) {
    var now = performance.now();
    if (now - lastDotTime > 50) { // ~20 per second
      activateDot(e.clientX, e.clientY);
      lastDotTime = now;
    }
  }, { passive: true });

  // Start loop
  requestAnimationFrame(animate);
})();
